import { render, staticRenderFns } from "./SuggestionSubSuccess.vue?vue&type=template&id=50ef1005&scoped=true"
import script from "./SuggestionSubSuccess.vue?vue&type=script&lang=js"
export * from "./SuggestionSubSuccess.vue?vue&type=script&lang=js"
import style0 from "./SuggestionSubSuccess.vue?vue&type=style&index=0&id=50ef1005&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ef1005",
  null
  
)

export default component.exports